import { IUpdateFornecedorBancoUseCase } from "../../../presentation/useCases/update/update_fornecedor_banco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateFornecedorBancoUseCase
 */

export class UpdateFornecedorBancoUseCase implements IUpdateFornecedorBancoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateFornecedorBanco(
    idFornecedor: number,
    idBanco: number,
    tipoConta: number,
    banco: string,
    agencia: string,
    conta: string,
    contaDigito: string,
    operacao: string,
    favorecido: string,
    cpfCnpj: string,
    pix: string,
  ): Promise<void> {
    await this.repository.updateFornecedorBanco(
      idFornecedor,
      idBanco,
      tipoConta,
      banco,
      agencia,
      conta,
      contaDigito,
      operacao,
      favorecido,
      cpfCnpj,
      pix,
    );
  }
}
